export const DEFAULT_VALUE = 50;

export const VALUE_OPTIONS = [25, 50, 100, 250];
